import { DownloadIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl, FormHelperText,
  Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  useDisclosure, useToast
} from "@chakra-ui/react";
import React, {useState} from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";

import { downloadCertificatesFiltered } from "../../shared/Api";
import { errorToast, successToast } from "../../shared/helper/ToastHelper";
import {CandidateFilterParams} from "../../shared/model/Dto";
import {teacherKeys} from "../../shared/QueryKeys";
import { extractData, saveByteArray } from "../../shared/Utils";

type DownloadFilesProps = {
  onFileSent?: (file: File) => void;
  buttonName: string;
  modalName: string;
  modalButton: string;
  candidateFilters?: CandidateFilterParams;
  isPublic?: boolean;
};

const DownloadFilesFromList = (props: DownloadFilesProps) => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);

  const useFilters = props.onFileSent===undefined;

  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  function handleDownloadClick() {
    if (file && !useFilters && props.onFileSent) {
      props.onFileSent(file);
    } else if (props.candidateFilters) {
        downloadCertificatesMutation.mutate();
    }
    onClose();
  }

  const downloadCertificatesMutation = useMutation(()=>downloadCertificatesFiltered(props.candidateFilters, props.isPublic),
    {
      onSuccess: (TData) => {
        successToast(toast, `Descargando`);
        saveByteArray("Constancias", TData.data);
        return queryClient.invalidateQueries(teacherKeys.userCertificates());
      },
      onError: () => {
        errorToast(toast, "Error descargando");
      },
    });

  return (
    <>
      <Button leftIcon={<DownloadIcon />} colorScheme="teal" onClick={onOpen}>
        {props.buttonName}
      </Button>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.modalName}</ModalHeader>
          {!useFilters &&
              <ModalBody>
                <FormControl id="file-form-control" paddingBottom="6">
                  <input name="file-input" type="file" onChange={handleChange} />
                  <FormHelperText>
                    Seleccione un archivo en formato xlsx.
                  </FormHelperText>
                </FormControl>
              </ModalBody>
          }
          <ModalCloseButton />
          <ModalFooter>
            <Button
              colorScheme="teal"
              type="submit"
              isDisabled={!useFilters && !file}
              onClick={handleDownloadClick}
            >
              {props.modalButton}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DownloadFilesFromList;
